import { LeftOutlined, RightOutlined } from "@ant-design/icons";
import "./ShamrockPage.scss";
import { Carousel } from "antd";
import { useRecoilState } from "recoil";
import { memberState } from "../../state/atoms";

export default function ShamrockPage() {
  const [member] = useRecoilState(memberState);
  function goToBrowse() {
    window.location.href = "/menu/browse.do";
  }

  const logosList = <>
    <div className="logo">
      <img src="https://timber.mhmcdn.com/site/content/shamrock/ElRanchoLogo.png" alt="El Rancho Logo" />
    </div>
    <div className="logo">
      <img src="https://timber.mhmcdn.com/site/content/shamrock/RawLogo.png" alt="NW Raw Logo" />
    </div>
    <div className="logo">
      <img src="https://timber.mhmcdn.com/site/content/shamrock/MochileroLogo.png" alt="Mochilero Logo" />
    </div>
    <div className="logo">
      <img src="https://timber.mhmcdn.com/site/marketing/homepage/home-logos/Club55Logo.jpeg" alt="Club 55 Logo" />
    </div>
    <div className="logo">
      <img src="https://timber.mhmcdn.com/site/marketing/homepage/home-logos/DoolittleLogo.jpeg" alt="Doolittle's Logo" />
    </div>
    <div className="logo">
      <img src="https://timber.mhmcdn.com/site/marketing/homepage/home-logos/DocsRibCageLogo.png" alt="Doc's Rib Cage Logo" />
    </div>
    <div className="logo">
      <img src="https://timber.mhmcdn.com/site/marketing/homepage/home-logos/HiltonLogo.jpeg" alt="Hilton Logo" />
    </div>
    <div className="logo">
      <img src="https://timber.mhmcdn.com/site/content/shamrock/CestBonLogo.png" alt="Cest Bon Logo" />
    </div>
    <div className="logo">
      <img src="https://timber.mhmcdn.com/site/marketing/homepage/home-logos/HardRockCafeLogo.jpeg" alt="Hard Rock Cafe Logo" />
    </div>
    <div className="logo">
      <img src="https://timber.mhmcdn.com/site/marketing/homepage/home-logos/KrazyKarlsLogo.jpeg" alt="Krazy Karl's Logo" />
    </div>
    <div className="logo">
      <img src="https://timber.mhmcdn.com/site/marketing/homepage/home-logos/MidCityTavernLogo.png" alt="Mid City Tavern Logo" />
    </div>
    <div className="logo">
      <img src="https://timber.mhmcdn.com/site/content/shamrock/MemoriesLogo.png" alt="Memories Charcoal House Logo" />
    </div>
    <div className="logo">
      <img src="https://timber.mhmcdn.com/site/marketing/homepage/home-logos/MickeySpillaneLogo.jpeg" alt="Mickey Spillane's Logo" />
    </div>
    <div className="logo">
      <img src="https://timber.mhmcdn.com/site/marketing/homepage/home-logos/OleLogo.png" alt="Ole Logo" />
    </div>
    <div className="logo">
      <img src="https://timber.mhmcdn.com/site/content/shamrock/PestoLogo.png" alt="Pesto Logo" />
    </div>
    <div className="logo">
      <img src="https://timber.mhmcdn.com/site/content/shamrock/RebelBBQLogo.png" alt="Rebel BBQ Logo" />
    </div>
    <div className="logo">
      <img src="https://timber.mhmcdn.com/site/content/shamrock/TheFortLogo.png" alt="The Fort Logo" />
    </div>
    <div className="logo">
      <img src="https://timber.mhmcdn.com/site/marketing/homepage/home-logos/RitzCarltonLogo.jpeg" alt="Ritz Carlton Logo" />
    </div>
    <div className="logo">
      <img src="https://timber.mhmcdn.com/site/content/shamrock/SarasPorchLogo.png" alt="Sara's Porch Logo" />
    </div>
    <div className="logo">
      <img src="https://timber.mhmcdn.com/site/content/shamrock/SidneyDairyBarnLogo.png" alt="Sidney Dairy Barn Logo" />
    </div>
    <div className="logo">
      <img src="https://timber.mhmcdn.com/site/marketing/homepage/home-logos/EmberLogo.jpeg" alt="Ember Woodfired Foods Logo" />
    </div>
    <div className="logo">
      <img src="https://timber.mhmcdn.com/site/content/shamrock/StuffedEatsLogo.png" alt="Stuffed Eats Logo" />
    </div>
    <div className="logo">
      <img src="https://timber.mhmcdn.com/site/marketing/homepage/home-logos/FlippinEggLogo.png" alt="That Flippin' Egg Logo" />
    </div>
    <div className="logo">
      <img src="https://timber.mhmcdn.com/site/marketing/homepage/home-logos/TheEmbassyLogo.png" alt="The Embassy Logo" />
    </div>
    <div className="logo">
      <img src="https://timber.mhmcdn.com/site/marketing/homepage/home-logos/BlockLogo.jpeg" alt="The Block Logo" />
    </div>
    <div className="logo">
      <img src="https://timber.mhmcdn.com/site/marketing/homepage/home-logos/TikisLogo.png" alt="Tiki's Logo" />
    </div>
    <div className="logo">
      <img src="https://timber.mhmcdn.com/site/marketing/homepage/home-logos/WhipLogo.png" alt="Whip Logo" />
    </div>
    <div className="logo">
      <img src="https://timber.mhmcdn.com/site/content/shamrock/FrankGrizzlysLogo.png" alt="Frank Grizzly's Logo" />
    </div>
    <div className="logo">
      <img src="https://timber.mhmcdn.com/site/content/shamrock/GinosLogo.png" alt="Gino's Logo" />
    </div>
  </>;

  return (
    <main className="shamrock-content">
      <section className="one text-center">
        <Carousel autoplay autoplaySpeed={8000} arrows nextArrow={<RightOutlined/>} prevArrow={<LeftOutlined/>} dots={false}>
          <div className="hero-slide smart">
            <div className="slide-overlay"/>
            <div className="slide-content">
              <img src="https://timber.mhmcdn.com/site/content/shamrock/MHMxShamrockLogo.svg" alt="MustHaveMenus x Shamrock Logo"/>
              <h1>Smart Designs for Restaurants</h1>
              <h3>See why over 10,000 restaurants use MustHaveMenus</h3>
            </div>
          </div>

          <div className="hero-slide market">
            <div className="slide-overlay"/>
            <div className="slide-content">
              <img src="https://timber.mhmcdn.com/site/content/shamrock/MHMxShamrockLogo.svg" alt="MustHaveMenus x Shamrock Logo"/>
              <h1>Market effectively.</h1>
              <h3>Create restaurant-style menus and promos with little effort. Connect with your customers everywhere in print or digital.</h3>
            </div>
          </div>

          <div className="hero-slide grow">
            <div className="slide-overlay"/>
            <div className="slide-content">
              <img src="https://timber.mhmcdn.com/site/content/shamrock/MHMxShamrockLogo.svg" alt="MustHaveMenus x Shamrock Logo"/>
              <h1>Grow sales.</h1>
              <h3>Sell more to repeat customers with a strong restaurant brand that communicates clearly and consistently across all channels.</h3>
            </div>
          </div>

          <div className="hero-slide reduce">
            <div className="slide-overlay"/>
            <div className="slide-content">
              <img src="https://timber.mhmcdn.com/site/content/shamrock/MHMxShamrockLogo.svg" alt="MustHaveMenus x Shamrock Logo"/>
              <h1>Reduce hassle.</h1>
              <h3>Skip the generic design apps. Use a tool built for restaurants that can reuse menu data and sync with your POS.</h3>
            </div>
          </div>
        </Carousel>
      </section>

      <section className="two text-center">
        <div className="content">
          <h2>Easily create effective menus and marketing</h2>
          <div className="flex">
            <div className="item">
              <a href="/feature/Print-Services.html">
                <img src="https://timber.mhmcdn.com/site/content/shamrock/TraditionalPrintThumb.webp" alt="Traditional print thumbnail" />
              </a>
              <h3>Traditional Print</h3>
              <p>Give your customers a beautiful printed menu to help create that timeless mystique of dining out.</p>
            </div>
            <div className="item">
              <a href="/feature/menu-qr-code.html">
                <img src="https://timber.mhmcdn.com/site/content/shamrock/QRCodesThumb.webp" alt="QR codes and web links thumbnail" />
              </a>
              <h3>QR Codes & Web links</h3>
              <p>Post your menus online in a mobile-optimized, Google-friendly format.</p>
            </div>
            <div className="item">
              <a href="/category/digital-menu-boards.html">
                <img src="https://timber.mhmcdn.com/site/content/shamrock/DigitalSignageThumb.webp" alt="Digital signage thumbnail" />
              </a>
              <h3>Digital Signage</h3>
              <p>Use our easy-to-edit menu board templates for your large-screen restaurant displays.</p>
            </div>
            <div className="item">
              <a href="/category/marketing-templates.html">
                <img src="https://timber.mhmcdn.com/site/content/shamrock/MarketingThumb.webp" alt="Marketing thumbnail" />
              </a>
              <h3>Marketing</h3>
              <p>Engage customers at your tables, at the register, in store windows, on social media, and more.</p>
            </div>
          </div>
        </div>
      </section>

      <section className={"perks-one"}>
      <div className="content">
        <h2>Perks of working with MustHaveMenus</h2>
        <div className={"flex"}>
          <div className={"half"}>
            <img src={"https://timber.mhmcdn.com/site/content/shamrock/MenuServices.webp"} alt="Menu Services"/>
          </div>
          <div className={"half"}>
            <h2>Menu Services</h2>
            <p>
              <b>Submit a request:</b> Select your service, then complete the submission form
            </p>
            <p>
              <b>Connect with a menu expert:</b> Once we've received your submission, we'll be in touch to confirm details and request payment
            </p>
            <p>
              <b>Get a menu within 1-2 business days, or less:</b> Our team will make the design available in your account, so you have complete access to the project
            </p>
            <p className="shamrock-perk">*Shamrock customers receive 75% off menu services!</p>
            <a href={member.id ? '/feature/book-demo-auth.html' : '/feature/book-demo-hello.html'} className={"ant-btn ant-btn-primary"} target="_blank" rel="noreferrer">Book a Demo</a>
          </div>
        </div>
      </div>
    </section>

    <section className={"perks-two"}>
      <div className="content">
        <div className={"flex reverse"}>
          <div className={"half"}>
            <img src={"https://timber.mhmcdn.com/site/content/resource-showcase/MenuSet.webp"} alt="Menu Set"/>
          </div>
          <div className={"half text"}>
            <h2>Membership Plans</h2>
            <p>
              <b>Free Access:</b> Ability to customize thousands of templates, download designs, and use QR codes.
            </p>
            <p>
              <b>7-day Free Trial:</b> Access to all pro features for 7 days. No card info required.
            </p>
            <p>
              <b>Paid Pro:</b> Access to every single template and feature. Upgrades from free trial to paid automatically after 7 days.
            </p>
            <p className="shamrock-perk">*Shamrock customers receive 20% off of their Pro Plan subscription! Use coupon code: SFSUB20 during checkout.</p>
            <a href={member.id ? '/feature/book-demo-auth.html' : '/feature/book-demo-hello.html'} className={"ant-btn ant-btn-primary"} target="_blank" rel="noreferrer">Book a Demo</a>
          </div>
        </div>
      </div>
    </section>

    <section className={"perks-three"}>
      <div className="content">
        <div className={"flex"}>
          <div className={"half"}>
            <img src={"https://timber.mhmcdn.com/site/content/resource-showcase/PrintServices.webp"} alt="Print Services"/>
          </div>
          <div className={"half text"}>
            <h2>Print Services</h2>
            <p>
              MustHaveMenus offers professional-quality printing for restaurants directly within our design app. It's just one click to all the options you'd expect from a top printer. We handle over 10,000 prints job a year across 14 different print products:
            </p>
            <p className="shamrock-perk">*Shamrock customers receive a 10% discount on all print orders. Use coupon code: SFPRINT10 during checkout.</p>
            <div className={"list-holder"}>
              <ul>
                <li>Traditional Menus</li>
                <li>Takeout Menus</li>
                <li>Half Page Menus</li>
                <li>Flyers</li>
                <li>Table Tents</li>
                <li>Kids Menus</li>
                <li>Posters</li>
              </ul>
              <ul>
                <li>Business Cards</li>
                <li>Loyalty Cards</li>
                <li>Stickers & Labels</li>
                <li>Sandwich Boards</li>
                <li>Gift Certificates</li>
                <li>Comment Cards</li>
                <li>Rack Cards</li>
              </ul>
            </div>
            <a href={member.id ? '/feature/book-demo-auth.html' : '/feature/book-demo-hello.html'} className={"ant-btn ant-btn-primary"} target="_blank" rel="noreferrer">Book a Demo</a>
          </div>
        </div>
      </div>
    </section>

      <section className="three gray-bg text-center">
        <div className="content">
          <h2>Self-Service &#8212; or &#8212; <br className="mobile-only"/>Have Us Do It</h2>
          <div className="flex">
            <div className="item">
              <img src="https://timber.mhmcdn.com/site/marketing/icons/PaintbrushIcon.svg" alt="Paintbrush icon"/>
              <p>Design that's easy for everyone.</p>
              <div className="ant-btn ant-btn-primary" onClick={goToBrowse}>Get Started</div>
            </div>
            <div className="item">
              <img src="https://timber.mhmcdn.com/site/marketing/icons/CustomerService.svg" alt="Customer service icon"/>
              <p>Our Menu Experts craft stunning menus for you that truly reflect your identity.</p>
              <a href={member.id ? '/feature/book-demo-auth.html' : '/feature/book-demo-hello.html'} className="ant-btn ant-btn-primary" target="_blank" rel="noreferrer">Book a Demo</a>
            </div>
          </div>
        </div>
      </section>

      <section className="four text-center">
        <div className="content">
          <h2>Trusted by restaurants everywhere</h2>
          <div className="moving-carousel">
            <div className="carousel-track">
              {/* Logos looped twice for animation */}
              {logosList}
              {logosList}
            </div>
          </div>
        </div>
      </section>

      <section className="five">
        <div className="content">
          <div className="flex">
            <div className="text">
              <img className="quotes" src="https://timber.mhmcdn.com/site/marketing/icons/Quotes.svg" alt="Red quotes"/>
              <img className="logo" src="https://timber.mhmcdn.com/site/content/shamrock/MochileroLogoWhite.svg" alt="Mochilero Kitchen logo"/>
              <h3>I always wanted to improve our menu. </h3>
              <p>
                In the past, we used graphic designers to create our menus, but simple menu updates could take weeks to get back and the designs didn't always meet our expectations. MustHaveMenus changed all that. Their friendly customer success team listened to my vision, took all my branding materials and menu data, and created a unique menu design that perfectly captures my restaurant. I love it!
              </p>
              <p><b>Jorge // Mochilero</b></p>
            </div>
            <div className="img">
              <img src="https://timber.mhmcdn.com/site/content/shamrock/MochileroKitchenHero.webp" alt="Mochilero Kitchen hero"/>
            </div>
          </div>
        </div>
      </section>

      <section className="six">
        <div className="content">
          <div className="flex">
            <div className="img">
              <img src="https://timber.mhmcdn.com/site/content/shamrock/DesignProductsHero.webp" alt="Design products hero"/>
            </div>
            <div className="text">
              <h2>Our Design Products</h2>
              <p>Explore over 25,000 templates tailored for restaurant marketing.</p>
              <div className="lists">
                <ul>
                  <li>Standard menus</li>
                  <li>Folded takeouts</li>
                  <li>Table tents</li>
                  <li>Half page menus</li>
                  <li>Kids menus</li>
                  <li>Business cards</li>
                  <li>Rack cards</li>
                  <li>Loyalty cards</li>
                  <li>Gift certificates</li>
                  <li>Posters</li>
                </ul>
                <ul>
                  <li>Flyers</li>
                  <li>Sandwich boards</li>
                  <li>Stickers</li>
                  <li>Digital menu boards</li>
                  <li>Online menu app</li>
                  <li>Linktree pages</li>
                  <li>QR codes</li>
                  <li>Social media posts</li>
                  <li>and more!</li>
                </ul>
              </div>
              <a href={member.id ? '/feature/book-demo-auth.html' : '/feature/book-demo-hello.html'} className="ant-btn ant-btn-primary" target="_blank" rel="noreferrer">Book a Demo</a>
            </div>
          </div>
        </div>
      </section>
    </main>
  )
}